import {
  h5,
} from './style'
import type { TypographyTypes } from 'types'

export const H5 = ({
  color,
  children,
  ...props
}: TypographyTypes) => {
  return (
    <h5
      style={{ color: `${color}` }}
      className={h5}
      {...props}
    >
      {children}
    </h5>
  )
}